import React, { useEffect, useState } from 'react'
import {
  Card,
  Divider,
  Row
} from 'antd'

import ProfileMenu from '../../../components/ProfileMenu'
import ScgFamilyConnectModal from '../../../components/scgFamily/scgFamilyConnectModal'
import Layout from '../../../layouts/User'
import styles from './index.module.scss'
import { useSelector } from 'react-redux'
import { numberFormat } from '../../../utils/display'

const SCGFamily: React.FC = () => {
  let [isConnected, setIsConnected] = useState(false)
  const user = useSelector((state: any) => state.user)

  const breadcrumbs = [
    {
      text: 'หน้าหลัก',
      path: '/'
    },
    {
      text: 'ข้อมูลของฉัน'
    }
  ]

  useEffect(() => {
    if (user.scgFamily) {
      setIsConnected(true)
    }
  }, [user])

  return (
    <>
      <div>
        <Row>
          <div className={styles.header}>สะสมคะแนนกับ SCG Family</div>
          <Divider
            style={{ background: 'black', margin: '15px 0' }}
          ></Divider>
        </Row>

        {!isConnected && (
          <>
            <div className={styles.contentText}>
              <div style={{ marginRight: '1rem' }}>
                <img
                  src="/images/scg-family.png"
                  alt="scg-family-logo"
                  className={styles.scgFamilyLogo}
                />
              </div>
              <div>ท่านยังไม่ได้เชื่อมต่อบัญชี SCG Family</div>
            </div>

            <div className={styles.buttonContainer}>
              <ScgFamilyConnectModal />
              <div>
                เชื่อมต่อบัญชีเพื่อ สะสมคะแนนและรับสิทธิประโยชน์มากมาย
              </div>
            </div>
          </>
        )}

        {isConnected && (
          <>
            <div className={styles.infoPane}>
              <div>
                <img
                  src="/images/scg-family.png"
                  alt="scg-family-logo"
                  className={styles.scgFamilyLogo}
                />
              </div>
              <div style={{ width: '100%' }}>
                <div
                  className={[styles.infoRow, styles.remaining].join(' ')}
                >
                  <div style={{ textAlign: 'left' }}>คะแนนคงเหลือ</div>
                  <div className={styles.red}>
                    {user.scgFamily &&
                      user.scgFamily.pointSummary &&
                      numberFormat(
                        user.scgFamily.pointSummary.totalpoint
                      )}
                  </div>
                </div>
                <div className={styles.infoRow}>
                  <div style={{ textAlign: 'left' }}>
                    คะแนนใกล้หมดอายุ (
                    {
                      user.scgFamily.pointSummary
                        .soonexpirepointmonthyear_thai
                    }
                    )
                  </div>
                  <div>
                    {user.scgFamily &&
                      user.scgFamily.pointSummary &&
                      numberFormat(
                        user.scgFamily.pointSummary.soonexpirepoint
                      )}
                  </div>
                </div>
                <div className={styles.infoRow}>
                  <div style={{ textAlign: 'left' }}>SCG Family ID</div>
                  <div>{user?.scgFamily?.scgId}</div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className={styles.redeem}>
          <a
            href="https://scg.buzzebees.com/privilege"
            target="_blank"
            rel="noopener noreferrer"
          >
            แลกคะแนนและดูสิทธิประโยชน์
          </a>
        </div>
      </div>
    </>
  )
}

export default SCGFamily
